import { reportChangeSolutionFronts } from 'analytics/reporters';
import { ComponentIds } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages } from '@inter-ikea-storageone/range';
import { addFrontStyleToFrame } from 'rangeConfig/shared/utils/frontLayouts';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import { hidePlatsaAddingFrontToOpenFrameErrorMessage } from '../rules/hideMenuRules';

const addFrontStyleToFrameBehavior = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  },
  props
}: BehaviorParameters) => {
  const placementAttemptErrorMessage = !hideNoFramesInSceneErrorMessage(coreApi)
    ? ErrorMessages.NoFramesInScene
    : !hidePlatsaAddingFrontToOpenFrameErrorMessage(coreApi)
    ? ErrorMessages.PlatsaAddingDoorsToOpenFrames
    : null;
  if (placementAttemptErrorMessage) {
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
  }
  const frontId = props.coreProductIds?.length > 0 ? props.coreProductIds[0] : props.coreProductId;

  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity && !props.position) return;

  const targetEntity =
    selectedEntity ??
    coreApi.entities.getEntityClosestToPosition(props.position, [ComponentIds.FRAME_COMPONENT_ID]);

  if (targetEntity?.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
    const frontStyleProduct = products.find(product => product.coreProductId === frontId);
    if (frontStyleProduct) {
      addFrontStyleToFrame(frontStyleProduct, targetEntity, products, coreApi);
      reportChangeSolutionFronts({
        color: `${frontStyleProduct.name} ${frontStyleProduct.design}`
      });
    }
  }
};

export default addFrontStyleToFrameBehavior;
